import React from 'react'
import SubNavbar from './SubNavbar'
import Navbar from './Navbar'
// import Preloader from './Preloader'

function AllComp() {
    return (
        <div>
            {/* <Preloader />; */}
            <SubNavbar />;
            <Navbar />;
        </div>
    )
}

export default AllComp
